import { Grid } from "@material-ui/core";
import { FunctionComponent } from "react";
import styled from "styled-components";
import { PrimaryButton } from "../../../../../../../../components/button";
import { Icon } from "../../../../../../../../components/icons";
import {
  CenteredFlex,
  columnFlex,
  Flex,
} from "../../../../../../../../components/layout";
import { size } from "../../../../../../../../styles/media";
import { FormWidget } from "../../../../common/components";

const StyledWidget = styled(FormWidget)`
  flex-grow: 1;
  display: flex;
`;

const MainIcon = styled(Icon)`
  height: 8em;
  width: 8em;
  margin: 2em 0;
`;

const Wrapper = styled(Flex)`
  ${columnFlex};
  ${CenteredFlex};
  max-width: 100%;
  flex-grow: 1;
`;

const Title = styled.h1`
  @media (max-width: ${size.tablet - 1}px) {
    margin-top: 0;
  }
`;

const ResultPage: FunctionComponent<{
  numberOfKycs: number;
  index: number;
  goToNextKyc: () => void;
}> = ({
  numberOfKycs,
  index,
  goToNextKyc
}) => (
    <StyledWidget>
      <Wrapper>
        <Title>Success!</Title>
        <MainIcon type="veryGoodCheck" />
        <p>
          Successfully completed this KYC. Proceed to the next entries or/and
          submit when ready.
        </p>
        {numberOfKycs - 1 > index && (<Grid item xs={12}>
          <PrimaryButton onClick={goToNextKyc}>Go to KYC {index + 2}</PrimaryButton>
        </Grid>)}
      </Wrapper>
    </StyledWidget>
  );

export default ResultPage;
